module.exports = __webpack_public_path__ + "media/images/checkmark-sm-ad63c91b972f63cc33a35bcf7415741e.svg";